import { Box, Flex, SectionTitle, Text, FormTextField, FormNumberInput } from '@shared/components';

export default function OverviewSectionFormField() {
  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      <SectionTitle title='QConfig Overview' />
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Box sx={{ minWidth: '240px' }}>
          <Text variant='body1Semibold'>ข้อมูลพื้นฐาน</Text>
        </Box>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4), width: '100%' }}>
          {/*TODO: change it to FormTextField when Form ready*/}
          <FormTextField
            label='ชื่อ QConfig'
            name='overview.name'
            placeholder='กรอกชื่อ QConfig'
            required
          />
          <FormNumberInput
            label='จำนวน QConfig'
            name='overview.total'
            placeholder='ระบุจำนวน QConfig'
            required
            helperText='สร้างได้สูงสุดครั้งละ 10 แบบเท่านั้น'
            sx={{ width: '200px' }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
